<template>
  <div class="page">
    <div class="screenLine">
      <div class="drawerComR" style="display: flex">
        <div class="imgItem" style="display: inline-block">
          <img alt="" :src="coverImg" v-if="coverImg" class="avatar" />
          <i
            class="el-icon-error closeBtn"
            v-if="coverImg"
            @click="handleDeleteCoverImgClick"
          ></i>
        </div>
        <i
          class="el-icon-plus avatar-uploader-icon"
          @click="handleUploadClicks"
          size="35"
          v-if="!coverImg"
        ></i>
        <input
          type="file"
          ref="files"
          style="width: 0; height: 0"
          @change="changeFiles"
        />
      </div>
    </div>
    <div class="btn" @click="handleSunmitClick">确定</div>
  </div>
</template>
  
  <script>
import { updatePhoto } from "../../../api/purchaseApi.js";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    pic: {
      default: "",
    },
  },
  data() {
    return {
      coverImg: "",
    };
  },
  mounted() {
    // console.log("交宠照片321", this.pic);
    if (this.pic) {
      this.coverImg = this.pic;
    }
    // this.getphoto();
  },
  methods: {
    //转移详情
    handleUploadClicks() {
      this.$refs.files.click();
    },
    //上传封面图
    changeFiles(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$upload
          .uploadImg_dir(formData, { dir: "businessShopImg" })
          .then((data) => {
            if (data.timestamp) {
              that.coverImg = data.url;
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //删除封面图
    handleDeleteCoverImgClick() {
      this.coverImg = "";
    },
    //提交
    handleSunmitClick() {
      let params = {
        petId: this.id,
        pic: this.coverImg,
      };
      console.log(params);
      updatePhoto(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "已变更",
          });
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.page {
  min-height: 734px;
  //   background: #fff;
  margin-top: 12px;
  font-size: 14px;
}
.screenLine {
}
// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  width: 300px;
  height:450px;
  // background: #979797;
  line-height: 450px;
  text-align: center;
  font-size: 30px;
  color: #8c939d;
}

.avatar {
  // margin: 20px;
  width: 300px;
  height:450px;
  display: block;
  object-fit: cover;
}

.btn {
  margin-top: 10px;
  margin-left: 30px;
  width: 98px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  margin-left: 20px;
}
</style>